import React, { Component } from 'react';
import Form from './Form';
import Edit from '../../common/Edit';
export default class OrderItemEdit extends Component {
  render() {
    return (
      <Edit
        resource={'ticketOrderItem'}
        resourceId={this.props.params.id}
        component={Form}
      />
    );
  }
}
